var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59995 19.8C0.839951 19.8 0.199951 19.16 0.199951 18.4V1.60001C0.199951 0.840012 0.839951 0.200012 1.59995 0.200012H30.4C31.16 0.200012 31.7999 0.840012 31.7999 1.60001V18.4C31.7999 19.16 31.16 19.8 30.4 19.8H1.59995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 0.4C31.06 0.4 31.6 0.94 31.6 1.6V18.4C31.6 19.06 31.06 19.6 30.4 19.6H1.6C0.94 19.6 0.4 19.06 0.4 18.4V1.6C0.4 0.94 0.94 0.4 1.6 0.4H30.4ZM30.4 0H1.6C0.72 0 0 0.72 0 1.6V18.4C0 19.28 0.72 20 1.6 20H30.4C31.28 20 32 19.28 32 18.4V1.6C32 0.72 31.28 0 30.4 0Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 6.29999L14.3 13.7H12.38L13.96 6.29999H15.88ZM23.94 11.08L24.94 8.29999L25.52 11.08H23.94ZM26.08 13.72H27.86L26.32 6.31999H24.68C24.32 6.31999 24 6.53999 23.86 6.85999L20.98 13.72H23L23.4 12.62H25.86L26.08 13.72ZM21.08 11.3C21.08 9.33999 18.38 9.23999 18.4 8.35999C18.4 8.09999 18.66 7.81999 19.22 7.73999C19.5 7.69999 20.26 7.67999 21.1 8.07999L21.44 6.49999C20.98 6.33999 20.38 6.17999 19.64 6.17999C17.74 6.17999 16.42 7.17999 16.4 8.61999C16.38 9.67999 17.36 10.28 18.08 10.64C18.82 11 19.08 11.24 19.08 11.56C19.08 12.06 18.48 12.28 17.94 12.28C16.98 12.3 16.42 12.02 15.98 11.82L15.64 13.44C16.08 13.64 16.92 13.82 17.78 13.84C19.76 13.82 21.08 12.84 21.08 11.3ZM13.14 6.29999L10.04 13.7H8.01999L6.47999 7.79999C6.37999 7.43999 6.29999 7.29999 6.01999 7.13999C5.55999 6.89999 4.79999 6.65999 4.12 6.51999L4.15999 6.29999H7.41999C7.83999 6.29999 8.19999 6.57999 8.29999 7.05999L9.09999 11.34L11.1 6.29999H13.14Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.70139,
    y1: 11.801,
    x2: 26.6936,
    y2: 7.95939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22275D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24479B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.25cf4f5dfc0faf149406a386e82d5c5e.svg";
export { ForwardRef as ReactComponent };